import "./projects.css"; 

import react from '../props/proje-ico/react.png'
import html from '../props/proje-ico/html.png'
import Cico from '../props/proje-ico/css.png'
import tailwind from '../props/proje-ico/Tailwind.png'
import js from '../props/proje-ico/js.png'
import boo from '../props/proje-ico/bootstrap.png'
import laravel from '../props/proje-ico/laravel.png'
import comma from '../props/proje-ico/comma.png'
import colon from '../props/proje-ico/colon.png'



const Projects = () => {
  
  return (
    <div id="projects" className=" projects-container">
      <h1 className="project-txt">PROJECTS</h1>

      <div className="project ">
        <div className="project-img img-i" ></div>
        <div className="project-info">
          <h1 className="name">PlayKoDEX</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={react}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={tailwind}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    </h3>
          <h4 className="about">
          PlayKoDEX: Your gaming hub for exploring games, staying informed, and getting the latest gaming news. Developed during the KodeGo Bootcamp, dive into an immersive world of gaming excitement.
          </h4>
            <div className="link-container">
              <a href="https://github.com/adas0mahdi/playkodex.git" rel="noreferrer" target="_blank" className="contact-project"  id="butt-one">
                <span >GitHub</span>
                
              </a>
              <a href="https://playkodex.vercel.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>
      <div className="project ">
        <div className="project-img img-a"></div>
        <div className="project-info">
          <h1 className="name">CineZone</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={react}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={boo}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    </h3>
          <h4 className="about">
          CineZone: Ignite your film passion! Discover, connect, and embark on a cinematic journey. Explore genres, watch trailers, and join a vibrant movie community. Unforgettable movie experiences await!
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/CineZone.git" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://peaceful-granita-bdd6ad.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>
      <div className="project ">
        <div className="project-img img-g"></div>
        <div className="project-info">
          <h1 className="name">feedback</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={laravel}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={boo}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    </h3>
          <h4 className="about">
          Revolutionize feedback management with Feedback! Streamline processes, gain insights, enhance satisfaction effortlessly, and take your success to new heights. Elevate your approach now for a feedback-driven transformation!
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/feedback.php.git" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://example.com" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>
      <div className="project ">
        <div className="project-img img-b"></div>
        <div className="project-info">
          <h1 className="name">HotelResponsive</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={html}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={Cico}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    </h3>
          <h4 className="about">
          Indulge in luxury at HotelResponsive! Captivating design, seamless navigation, exclusive accommodations. Book your dream stay, create unforgettable memories. Elevate your travel experience now!
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/03_HotelResponsive.git" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://fantastic-melomakarona-f46d09.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>
      <div className="project ">
        <div className="project-img img-c"></div>
        <div className="project-info">
          <h1 className="name">KodeResto</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={html}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={Cico}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    </h3>
          <h4 className="about">
              Experience culinary perfection at KodeResto! Discover tantalizing flavors, an enchanting atmosphere, and impeccable service. Indulge in a memorable dining adventure that blends taste, ambiance, and hospitality.
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/08_KodeResto.git" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://jazzy-heliotrope-8d236f.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>


      <div className="project ">
        <div className="project-img img-m"></div>
        <div className="project-info">
          <h1 className="name">Grocery List</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={html}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={Cico}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={js}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    
                    </h3>
          <h4 className="about">
          "Grocery List simplifies shopping. Create, share, and budget effortlessly. Stay organized with custom lists. Access from anywhere. Secure and free. Upgrade your shopping today!
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/Grocery-List" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://spiffy-peony-6232c0.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>
      <div className="project ">
        <div className="project-img img-l"></div>
        <div className="project-info">
          <h1 className="name">Tic Tac Toe</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={html}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={Cico}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={js}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    
                    </h3>
          <h4 className="about">
          Experience the joy of a timeless game with this captivating Tic-Tac-Toe project! Built with simple rules and a nostalgic touch, challenge yourself to win 3 in a row and relive the fun memories of this classic game!
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/tic-tac-toe.git" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://majestic-lokum-1953b5.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>


      <div className="project ">
        <div className="project-img img-n"></div>
        <div className="project-info">
          <h1 className="name">Juice Website</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={html}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={Cico}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={js}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    
                    </h3>
          <h4 className="about">
          Experience the future of web design on the Responsive Juice Website. From luscious visuals to flawless responsiveness, it's a digital treat. Dive in now!
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/responsive-juice-website-main" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://effortless-dolphin-5f3030.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>
      <div className="project ">
        <div className="project-img img-d"></div>
        <div className="project-info">
          <h1 className="name">image search engine</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={html}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={Cico}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={js}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    
                    </h3>
          <h4 className="about">
          Unleash the power of visual exploration with our Image Search Engine. Find perfect images effortlessly, refine your search, and fuel your creativity. Discover the world through visuals! Try it now!
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/image-search-engine.git" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://preeminent-pony-b66f6f.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>
      <div className="project ">
        <div className="project-img img-e"></div>
        <div className="project-info">
          <h1 className="name">KodeShop</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={react}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={boo}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    </h3>
          <h4 className="about">
          Shop seamlessly with KodeShop! Explore a wide range of products, from electronics to fashion, all in one place. Enjoy secure transactions, efficient order management, and exceptional customer support. Elevate your shopping experience today!
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/KodaShop-2023.git" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://assignment2203.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>
      <div className="project ">
        <div className="project-img img-j"></div>
        <div className="project-info">
          <h1 className="name">Dice Roll</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={react}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={boo}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    </h3>
          <h4 className="about">Welcome to the React Dice Game! 
A simple web app using React & Bootstrap for simulating dice rolls.
Try your luck with specified dice and enjoy random outcomes!
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/dice.git" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://jade-arithmetic-ce760a.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>

      <div className="project ">
        <div className="project-img img-f"></div>
        <div className="project-info">
          <h1 className="name">Kodeledger</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={html}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={Cico}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    </h3>
          <h4 className="about">
          Take control of your finances with Kodeledger! Simplify bookkeeping, track transactions, and gain financial clarity effortlessly. Experience seamless financial management and empower your financial success today!
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/04_Kodeledger.git" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://classy-tanuki-9fd502.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>
      <div className="project ">
        <div className="project-img img-h"></div>
        <div className="project-info">
          <h1 className="name">NewsGrid</h1>
          <h3 className="languageUsed"><span>Tools</span>
                     <img
                      src={colon}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '10px 0 0 0',
                      }}
                    />
                    <img
                      src={html}
                      alt="Icon"
                      style={{
                        width: '35px',
                        height: '35px',
                      }}
                    />
                      <img
                      src={comma}
                      alt="Icon"
                      style={{
                        width: '10px',
                        height: '10px',
                        margin: '25px 5px 0 5px',
                      }}
                    />
                    <img
                      src={Cico}
                      alt="Icon"
                      style={{
                        width: '30px',
                        height: '30px',
                      }}
                    />
                    </h3>
          <h4 className="about">
          Stay updated with NewsGrid, the ultimate news website template. Explore captivating articles, diverse categories, and seamless reading across all devices. Your go-to destination for news that matters.
          </h4>
          <div className="link-container">
              <a href="https://github.com/adas0mahdi/NewsGrid.git" className="contact-project" id="butt-one" rel="noreferrer" target="_blank">
                <span >GitHub</span>
              </a>
              <a href="https://inquisitive-pegasus-0f1ad2.netlify.app/" className="contact-project "  id="butt-two" rel="noreferrer" target="_blank"> 
                <span id="link" >Link</span>
              </a>
            </div>
        </div>
      </div>
      

    </div>
  );
};

export default Projects;